import { render, staticRenderFns } from "./ComboVariant.vue?vue&type=template&id=1840e6a4&scoped=true&"
import script from "./ComboVariant.vue?vue&type=script&lang=js&"
export * from "./ComboVariant.vue?vue&type=script&lang=js&"
import style0 from "./ComboVariant.vue?vue&type=style&index=0&id=1840e6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840e6a4",
  null
  
)

export default component.exports